<p-card>
  <div class="flex justify-between mx-auto w-full md:relative">
    <h2 class="font-app-medium text-black hidden md:block md:p-2">
      {{ "storedDocuments.category.title" | translate }}
    </h2>
    <button
      class="hidden md:block md:absolute md:right-0 md:mt-2"
      title="Informations"
      (click)="uploadInfo.toggle($event)">
      <i class="pi pi-info-circle text-medium_light text-xl h-7 aspect-square text-center"></i>
    </button>
    <p-overlayPanel #uploadInfo>
      <p class="text-black">
        {{ "storedDocuments.category.toggleInfo1" | translate }}
      </p>
      <p
        [innerHtml]="'storedDocuments.category.toggleInfo2' | translate"
        class="text-black mt-4"></p>
    </p-overlayPanel>
  </div>
  <ul class="-mt-5 md:border-[1px] md:mx-auto md:rounded-lg md:border-light md:mt-3">
    <li
      *ngFor="let category of workingCategories; let i = index"
      class="border-b border-light p-3 md:p-2 flex justify-between items-center font-app-light">
      <div class="flex items-center">
        <input
          pInputText
          *ngIf="editingIndex === i && category.isCustom"
          [(ngModel)]="category.name"
          (blur)="saveCategory(i)"
          class="p-inputtext p-component text-black"
          placeholder="Modifier la catégorie"
          #editCategoryInput />
        <span
          *ngIf="editingIndex !== i || !category.isCustom"
          (click)="category.isCustom ? editCategory(i) : null"
          class="flex-initial text-black font-app-regular p-2 cursor-pointer"
          [class.disabled]="!category.isCustom">
          {{ category.isCustom ? category.name : (getGenericCategoryTranslationUri(category.name) | translate) }}
        </span>
        <div
          *ngIf="category.documentCount"
          class="bg-primary/60 text-white font-bold text-center text-[0.6rem] h-5 w-5 leading-4 px-1 rounded-full flex items-center justify-center ml-2">
          <span>{{ category.documentCount }}</span>
        </div>
      </div>
      <button
        pButton
        *ngIf="category.isCustom && category.documentCount === 0"
        (click)="deleteCustomCategory(i)">
        <i class="pi pi-times w-9 text-lg text-black"></i>
      </button>
    </li>
    <li
      *ngIf="addingNewCategory"
      class="border-b border-light p-4 text-black">
      <input
        #newCategoryInput
        pInputText
        [(ngModel)]="newCategoryName"
        (blur)="addCategory()"
        class="p-inputtext p-component"
        placeholder="Nouvelle catégorie" />
    </li>
    <li class="border-b border-light p-4">
      <button
        pButton
        type="button"
        (click)="startAddingCategory()"
        class="p-button text-primary">
        <i class="pi pi-plus"></i>
        <span class="font-app-regular ml-3">{{ "storedDocuments.category.addCategory" | translate }}</span>
      </button>
    </li>
  </ul>
  <div class="flex flex-col md:flex-row-reverse gap-3 mt-4 p-6 md:p-0">
    <button
      pButton
      type="button"
      label="Valider"
      (click)="saveCategories()"
      class="p-button text-white bg-primary border-2 rounded-lg px-6 py-3 w-full"></button>
    <button
      pButton
      type="button"
      label="Annuler"
      (click)="cancelCategories()"
      class="p-button text-primary bg-white border-[1px] rounded-lg px-6 py-3 w-full"></button>
  </div>
</p-card>

